import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Pricing } from './components/Pricing';
import { Process } from './components/Process';
import { Zones } from './components/Zones';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { Faq } from './components/Faq';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { MobileCallBar } from './components/MobileCallBar';
export function App() {
  return <div className="min-h-full w-full bg-bone" data-id="element-0" data-mp="31b8gdpflpv4z">
      <Header data-id="element-1" data-mp="31c1ksjr388jy" />
      <main data-id="element-2" data-mp="31cjou2jzrr2f">
        <Hero data-id="element-3" data-mp="2wka18t6cn33b" />
        <Services data-id="element-4" data-mp="2wjgq7g0cxrfd" />
        <Pricing data-id="element-5" data-mp="2wiyuqllirh8i" />
        <Process data-id="element-6" data-mp="2wifbn1k4umsw" />
        <Zones data-id="element-7" data-mp="2whxcnx635uha" />
        <About data-id="element-8" data-mp="28ufoscpxzgjl" />
        <Testimonials data-id="element-9" data-mp="28tw4wqgqei2x" />
        <Faq data-id="element-10" data-mp="28te3zgj4jfoo" />
        <Contact data-id="element-11" data-mp="28suvsrja05nu" />
      </main>
      <Footer data-id="element-12" data-mp="28s2z1ddy01vz" />
      <MobileCallBar data-id="element-13" data-mp="23vkv2fqfs7kp" />
    </div>;
}